import { find } from 'fxjs/es';
import { NewMakerSGuide } from '../../../S/module/NewMakerSGuide.js';

export const findBp = (base_product_id) => {
  return find((bp_id) => {
    return base_product_id == bp_id;
  }, NewMakerSGuide.GUIDE_DATA.image_quality.base_product_ids);
};
